import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import VnButton from '@ui/components/VnButton';
import { printOutline, saveOutline, trashOutline, pricetagOutline, cartOutline, add } from 'ionicons/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import Select from 'react-select';
import { statusDropDownStyles } from '@ui/styles/status-dropdown-style';
import NotesTab from './notes/NotesTab';
import AttachmentTab from './attachment/AttachmentTab';
import OrderLineTab from './orderLine/OrderLineTab';
import AddOrderFormInfoTab from './info/AddOrderFormInfoTab';
import OrderTabsHelpers from './orderHelpers';
import { createOrderAsync, deleteOrderByIdAsync, generateOrderPdfAsync, generatePriceRequestPdfAsync, getAllOrderStatusAsync, getOrderByIdAsync, updateOrderAsync, updateOrderStatusByIdAsync } from '@application/features/orders/orderThunk';
import { OrderStatus } from '@application/common/enums/order-status';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { IonIcon } from '@ionic/react';
import ModalPopup from '@ui/components/VnModal';
import PriceRequestPrintPreview from '../PriceRequestPrintPreview';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { getAllWorkOrdersByIdAsync, updateModulePermissionsStatusAsync, updateWorkOrderStatusById } from '@application/features/workorders/workorderThunk';
import { WorkorderStatus } from '@application/common/enums/workorder-status';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { formatDateDMY, handleRolePermission } from '@infrastructure/helpers';
import PriceRequestOrderLineViewTable from '../PriceRequestOrderLineViewTable';
import OrderPreview from './orderPreview';
import { CalculationSelectionForPurchaseInvoiceTable } from '../CalculationSelectionForPurchaseInvoiceTable';
import { TabNotification } from '@ui/components/VnTabNotification';
import { clearUpdateModulePermissionStatus, resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { useAsyncDebounce } from '@application/common/hooks/use-async-debounce';
import PersistentWarningMessage from '@ui/components/VnNotification/PersistantWarningMessage';
import PersistentInfoMessage from '@ui/components/VnNotification/PersistantInfoMessage';
import EmailEditorForm from '@ui/components/VnEmailEditor';
import { getCreditureByIdAsync } from '@application/features/creditures/creditureThunk';
import { getAllOrderLineByOrderIdAsync } from '@application/features/orderlines/orderLineThunk';
import { getEmailTemplateByNameAsync } from '@application/features/sendemail/sendemailThunk';
import { addErrorNotification } from '@application/features/common/notificationSlice';
const OrderView = () => {
    const [activeTab, setActiveTab] = useState('InfoTab');
    const dispatch = useAppDispatch();
    const [submitOrder, setSubmitOrder] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [disableRecord, setDisableRecord] = useState(false);
    const [isPriceRequestOrderLineTableOpen, setIsPriceRequestOrderLineTableOpen] = useState(false);
    const [isPriceRequestFormVisible, setIsPriceRequestFormVisible] = useState(false);
    const { OrderStatusDropdown } = useAppSelector((state) => state.order);
    const [isOrderDeleteConfirmationPopup, setOrderDeleteConfirmationPopup] = useState(false);
    const [filteredOrderLineList, setFilteredOrderLineList] = useState([]);
    const [isOrderPreviewOpen, setOrderPreviewOpen] = useState(false);
    const [receivedOrderStatus, setReceivedOrderStatus] = useState();
    const [isCalculationSelectionForPurchaseInvoiceTableOpen, setCalculationSelectionForPurchaseInvoiceTableOpen] = useState(false);
    const { moduleLocked, updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const [isAttachmentTabBold, setIsAttachmentTabBold] = useState(false);
    const [isOrderLineTabBold, setIsOrderLineTabBold] = useState(false);
    const { handleFieldChange, handleCalendarChange, validateForm, formData, setFormData, errors, handleToggelButtonChange, infoTabErrorBorderColor, isInfoTabUnsaved, isNotesTabUnsaved, isInfoTabBold, isNotesTabBold } = OrderTabsHelpers();
    const [orderPrintData, setOrderPrintData] = useState(formData);
    const [orderEmailTemplate, setOrderEmailTemplate] = useState('');
    const [priceRequestEmailTemplate, setPriceRequestEmailTemplate] = useState('');
    const { UpdateOrder } = useAppSelector((state) => state.order);
    const { orderLines } = useAppSelector((state) => state.orderLine);
    const { crediture } = useAppSelector((state) => state.crediture);
    VnDocumentTitle('Visser Bes-' + formData.orderNumber);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    useEffect(() => {
        dispatch(getAllOrderStatusAsync());
    }, []);
    useEffect(() => {
        if (id) {
            dispatch(getOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
                setOrderPrintData(res);
                setReceivedOrderStatus(res.statusId);
                if (res.statusId == OrderStatus.Inkoopfactuur_verwerkt || res.statusId == OrderStatus.Geannuleerd) {
                    setDisableRecord(true);
                }
            })
                .catch((error) => {
                navigate(`/admin/OrdersList`);
                console.error('Bad request.');
            });
        }
    }, [id]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitOrder) {
            if (!disableRecord) {
                var moduleLockStatus = await checkModulelock();
                if (moduleLockStatus == false) {
                    const triggeredErrors = validateForm();
                    if (Object.values(triggeredErrors).every((error) => !error)) {
                        if (!id) {
                            dispatch(createOrderAsync(formData))
                                .unwrap()
                                .then((res) => {
                                navigate(`/admin/OrderTabs/${res.id}`);
                            });
                        }
                        else {
                            dispatch(updateOrderAsync(formData))
                                .unwrap()
                                .then((res) => {
                                dispatch(getOrderByIdAsync(parseInt(id)))
                                    .unwrap()
                                    .then((res) => {
                                    setFormData(res);
                                    setOrderPrintData(res);
                                    setReceivedOrderStatus(res.statusId);
                                    if (res.statusId == OrderStatus.Inkoopfactuur_verwerkt ||
                                        res.statusId == OrderStatus.Geannuleerd) {
                                        setDisableRecord(true);
                                    }
                                });
                            });
                        }
                    }
                }
            }
            setSubmitOrder(false);
            if (formData.statusId == OrderStatus.In_bestelling && formData.workorderId != null) {
                dispatch(updateWorkOrderStatusById({
                    workOrderId: formData.workorderId,
                    statusId: WorkorderStatus.Delen_in_bestelling
                }));
            }
        }
        // else if (formData.statusId == OrderStatus.Ontvangen && formData.workorderId !=null ) {
        //     dispatch(
        //         updateWorkOrderStatusById({
        //             workOrderId: formData.workorderId,
        //             statusId: WorkorderStatus.Bestellingen_zijn_binnen
        //         })
        //     );
        // }
    };
    const handleStatusDropdownChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            statusId: selectedOption.value
        }));
    };
    const handleOrderDelete = () => {
        if (id) {
            dispatch(deleteOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/OrdersList'))
                .catch((error) => {
                setOrderDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelOrderDeleteClicked = () => {
        setOrderDeleteConfirmationPopup(false);
    };
    const handlePriceRequestPrintPreview = (filterOrderLineList) => {
        setIsPriceRequestFormVisible(true);
        setIsPriceRequestOrderLineTableOpen(false);
        setFilteredOrderLineList(filterOrderLineList);
    };
    useEffect(() => {
        if (id && UpdateOrder)
            setFormData((prevData) => ({
                ...prevData,
                statusId: UpdateOrder?.statusId,
                orderDate: UpdateOrder?.orderDate
            }));
    }, [id, UpdateOrder]);
    const handleCalculationForPurchaseInvoiceTableClose = () => {
        setCalculationSelectionForPurchaseInvoiceTableOpen(false);
    };
    // const handleSelectedCalculationForPurchaseInvoiceSubmit = (selectedCalculations: CalculationDto[]) => {
    //     if (formData.orderNumber && formData.id) {
    //         const orderData: LabelValueDto = {
    //             label: formData.orderNumber,
    //             value: formData.id
    //         };
    //         dispatch(setOrderNumberForPurchaseInvoice(orderData));
    //         dispatch(setSelectedCalculationForPurchaseInovice(selectedCalculations));
    //         navigate('/admin/PurchaseInvoicesTabs');
    //     }
    //     setCalculationSelectionForPurchaseInvoiceTableOpen(false);
    // };
    const cleanupPurchaseInvoiceTransferDataLocalStorageEntries = () => {
        const now = Date.now();
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('purchaseInvoiceData_')) {
                const data = JSON.parse(localStorage.getItem(key));
                if (now - data.timestamp > 3600000) { // 1 hour
                    localStorage.removeItem(key);
                }
            }
        });
    };
    const handleSelectedCalculationForPurchaseInvoiceSubmit = (selectedCalculations) => {
        cleanupPurchaseInvoiceTransferDataLocalStorageEntries();
        if (formData.orderNumber && formData.id) {
            const dataKey = `purchaseInvoiceData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            const storageData = {
                orderData: {
                    label: formData.orderNumber,
                    value: formData.id
                },
                calculations: selectedCalculations,
                timestamp: Date.now()
            };
            try {
                localStorage.setItem(dataKey, JSON.stringify(storageData));
                const url = `/admin/PurchaseInvoicesTabs?dataKey=${encodeURIComponent(dataKey)}`;
                window.open(url, '_blank');
            }
            catch (error) {
                console.error('Failed to save purchase invoice data:', error);
                dispatch(addErrorNotification('Kon gegevens niet opslaan voor inkoopfactuur'));
            }
        }
        else {
            dispatch(addErrorNotification('Ontbrekende ordergegevens'));
        }
        setCalculationSelectionForPurchaseInvoiceTableOpen(false);
    };
    const handleOrderStatusChange = () => {
        if (id) {
            dispatch(getOrderByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData((prevData) => ({
                    ...prevData,
                    statusId: res.statusId
                }));
                setReceivedOrderStatus(res.statusId);
            });
        }
    };
    const disabledStatuses = [OrderStatus.Ontvangen, OrderStatus.Retour_gestuurd];
    const modifiedOrderStatusDropdown = useMemo(() => {
        return OrderStatusDropdown?.map((option) => ({
            ...option,
            isDisabled: receivedOrderStatus !== undefined &&
                disabledStatuses.includes(receivedOrderStatus) &&
                [OrderStatus.Concept, OrderStatus.Prijs_aangevraagd, OrderStatus.In_bestelling].includes(option.value)
        }));
    }, [receivedOrderStatus, OrderStatusDropdown]);
    const handleFieldChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleFieldChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleFieldChangeWrapperForText = async (fieldName, value) => {
        handleFieldChange(fieldName, value); // Call the original handleFieldChange
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        // if (moduleLockStatus == false) {
        //     handleFieldChange(fieldName, value); // Call the original handleFieldChange
        // }
    };
    const handleCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleToggelButtonChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleToggelButtonChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Bestellingen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    useEffect(() => {
        return () => {
            dispatch(resetTimer());
            dispatch(unsetModuleLock());
            dispatch(clearUpdateModulePermissionStatus());
        };
    }, [resetTimer]);
    useEffect(() => {
        dispatch(unsetModuleLock());
    }, []);
    const checkModulelockandTimeTriggerForFields = async () => {
        if (formData.id) {
            dispatch(resetTimer());
            var result = false;
            // Call the debounced API function
            debouncedCheckModuleLockApiCall()
                .then((res) => {
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
                else {
                    dispatch(unsetModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
            })
                .catch(() => {
                dispatch(unsetModuleLock());
            });
            return result;
        }
        return false;
    };
    const checkModuleLockApiCall = async () => {
        const moduleLockRequestData = {
            moduleId: VisserModule.Bestellingen,
            recordId: formData.id
        };
        return await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
    };
    const debouncedCheckModuleLockApiCall = useAsyncDebounce(checkModuleLockApiCall, parseInt(process.env.REACT_APP_DEBOUNCE_TIME_FOR_MODULE_LOCK_API));
    const handleAttachmentTabBold = (state) => {
        setIsAttachmentTabBold(state);
    };
    const handleOrderLineTabBold = (state) => {
        setIsOrderLineTabBold(state);
    };
    //---------------- send Email
    const [isOrderSentAsEmailViewOpen, setIsOrderSentAsEmailViewOpen] = useState(false);
    const [orderDocument, setOrderDocument] = useState(null);
    const handelOrderSentAsEmailWithAttachmentPopup = () => {
        if (id && !isNaN(parseInt(id))) {
            dispatch(getEmailTemplateByNameAsync('SendOrderTemplate'))
                .unwrap()
                .then((res) => {
                if (res.body) {
                    const bodyOfEmail = res.body
                        .replace('[leverdatum]', orderPrintData?.deliveryDate ? formatDateDMY(orderPrintData?.deliveryDate) : '')
                        .replace('[contactpersoon]', orderPrintData?.referenceContactPersonName ? orderPrintData.referenceContactPersonName : '');
                    setOrderEmailTemplate(bodyOfEmail);
                    setOrderPreviewOpen(false);
                    setIsOrderSentAsEmailViewOpen(true);
                }
            })
                .catch((error) => { });
            if (orderPrintData?.workorderId) {
                dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)));
                dispatch(getCreditureByIdAsync(orderPrintData.supplierId));
                dispatch(getAllWorkOrdersByIdAsync(orderPrintData.workorderId))
                    .unwrap()
                    .then((workOrder) => {
                    if (orderPrintData.supplierId) {
                        var materials = {
                            orderNumber: orderPrintData.orderNumber,
                            technicianFirstName: workOrder?.technicianFirstName,
                            technicianLastName: workOrder?.technicianLastName,
                            name: crediture?.name,
                            address: crediture?.address,
                            postalCode: crediture?.postalCode,
                            city: crediture?.city,
                            description: workOrder?.description,
                            orderLines: orderLines,
                            referenceContactPersonName: orderPrintData.referenceContactPersonName,
                            supplierId: orderPrintData.supplierId
                        };
                        dispatch(generateOrderPdfAsync(materials))
                            .unwrap()
                            .then((res) => {
                            setOrderDocument('data:application/pdf;base64,' + res);
                        });
                    }
                })
                    .catch((error) => {
                    console.error('Bad request .');
                });
            }
        }
    };
    const handelOrderSentAsEmailClose = () => {
        setIsOrderSentAsEmailViewOpen(false);
        setOrderPreviewOpen(true);
    };
    //---------------- send Email of Cost Estimation
    const [isOrderPriceRequestSentAsEmailViewOpen, setIsOrderPriceRequestSentAsEmailViewOpen] = useState(false);
    const [orderPriceRequestDocument, setOrderPriceRequestDocument] = useState(null);
    const handelSendOrderPriceRequestPDfInEmailPopup = () => {
        dispatch(getEmailTemplateByNameAsync('SendPriceRequestTemplate'))
            .unwrap()
            .then((res) => {
            if (res.body) {
                setPriceRequestEmailTemplate(res.body);
                setIsOrderPriceRequestSentAsEmailViewOpen(true);
                setIsPriceRequestFormVisible(false);
            }
        })
            .catch((error) => { });
        if (id && !isNaN(parseInt(id))) {
            //----------------------
            if (orderPrintData?.workorderId) {
                dispatch(getCreditureByIdAsync(orderPrintData.supplierId));
                dispatch(getAllWorkOrdersByIdAsync(orderPrintData.workorderId))
                    .unwrap()
                    .then((workOrder) => {
                    var materials = {
                        orderNumber: orderPrintData.orderNumber,
                        technicianFirstName: workOrder?.technicianFirstName,
                        technicianLastName: workOrder?.technicianLastName,
                        name: crediture?.name,
                        address: crediture?.address,
                        postalCode: crediture?.postalCode,
                        city: crediture?.city,
                        description: workOrder?.description,
                        orderLines: filteredOrderLineList,
                        supplierId: orderPrintData.supplierId
                    };
                    dispatch(generatePriceRequestPdfAsync(materials))
                        .unwrap()
                        .then((res) => {
                        setOrderPriceRequestDocument('data:application/pdf;base64,' + res);
                    });
                })
                    .catch((error) => {
                    console.error('Bad request .');
                });
            }
            //----------------------
        }
    };
    const handelSendOrderPriceRequestPDfInEmailPopupClose = () => {
        setIsOrderPriceRequestSentAsEmailViewOpen(false);
        setIsPriceRequestFormVisible(true);
    };
    //---------------- send Email
    const handleEmailSendSuccessForOrder = (value) => {
        if (value) {
            handelOrderSentAsEmailClose();
            const updatedFormData = {
                ...orderPrintData,
                orderDate: new Date(),
                statusId: OrderStatus.In_bestelling
            };
            dispatch(updateOrderAsync(updatedFormData))
                .unwrap()
                .then((res) => {
                dispatch(getOrderByIdAsync(res.id))
                    .unwrap()
                    .then((res) => {
                    setFormData(res);
                })
                    .catch((error) => { });
            })
                .catch((error) => { });
        }
    };
    const handleEmailSendSuccessForPriceRequest = (value) => {
        if (value) {
            handelSendOrderPriceRequestPDfInEmailPopupClose();
            dispatch(updateOrderStatusByIdAsync({
                orderId: orderPrintData.id,
                statusId: OrderStatus.Prijs_aangevraagd
            }))
                .unwrap()
                .then((res) => {
                handleOrderStatusChange();
            })
                .catch((error) => { });
        }
    };
    const handleOrderOnModuleLockReset = (value) => {
        if (value) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => !error)) {
                dispatch(updateOrderAsync(formData));
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { className: 'ml-1 mb-1', children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Bestellingen" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/OrdersList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: cartOutline, className: 'vn-breadcrum-icon' }) }), "Bestellingen"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formData.orderNumber })] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                    (handleRolePermission(Permission.BESTELLINGEN, PermissionType.Delete) && id && !disableRecord
                                                        ? false
                                                        : true), onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setOrderDeleteConfirmationPopup(true);
                                                    }
                                                }, type: 'button' }), _jsx(VnButton, { icon: printOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon', onClick: (event) => {
                                                    event.preventDefault();
                                                    setOrderPreviewOpen(true);
                                                }, isDisabled: moduleLocked || !id, type: 'button' }), formData.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', type: 'submit', onClick: () => {
                                                    setSubmitOrder(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                    !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) ||
                                                    disableRecord })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', type: 'submit', onClick: () => {
                                                    setSubmitOrder(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                    !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) ||
                                                    disableRecord }))] })] }), _jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-8 vn-workorder-status-container', children: [_jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: pricetagOutline, mode: 'primary', type: 'button', isDisabled: id && !disableRecord ? false : true, onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setIsPriceRequestOrderLineTableOpen(true);
                                                    }
                                                }, children: "Prijsaanvraag" }), _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: add, mode: 'primary', type: 'button', isDisabled: id && !disableRecord ? false : true, onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setCalculationSelectionForPurchaseInvoiceTableOpen(true);
                                                    }
                                                }, children: "Inkoopfacturen boeken" })] }), _jsx("div", { className: 'col-sm-4 vn-status-col', style: { display: 'flex', justifyContent: 'end', flexWrap: 'wrap' }, children: _jsxs("div", { style: { display: 'flex' }, children: [_jsx("label", { className: 'vn-status-label', children: "Status:" }), _jsx(Select, { isSearchable: false, options: modifiedOrderStatusDropdown, styles: statusDropDownStyles, value: modifiedOrderStatusDropdown?.find((option) => option.value === formData.statusId), onChange: handleStatusDropdownChange, isDisabled: disableRecord })] }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                            ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(AddOrderFormInfoTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, onToggleButtonChange: handleToggelButtonChangeWrapper, disableRecord: disableRecord }) }), _jsx(Tab, { eventKey: 'OrderLineTab', title: 'Bestelregels', tabClassName: `${isOrderLineTabBold ? 'has-data' : ''}
                         `, children: _jsx(OrderLineTab, { disableRecord: disableRecord, formData: formData, handleFieldChange: handleFieldChangeWrapperForText, handleOrderStatusChange: handleOrderStatusChange, isOrderLineTabBold: handleOrderLineTabBold }) }), _jsx(Tab, { eventKey: 'NotesTab', title: TabNotification('Notities', false, isNotesTabUnsaved), tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, disableRecord: disableRecord }) }), _jsx(Tab, { eventKey: 'AttachmentsTab', title: 'Bijlagen', tabClassName: `${isAttachmentTabBold ? 'has-data' : ''}
                         `, disabled: id === undefined, children: _jsx(AttachmentTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapper, onCalendarChange: handleCalendarChangeWrapper, disableRecord: disableRecord, isAttachmentTabBold: handleAttachmentTabBold }) })] })] }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de bestelling worden permanent verwijderd. Weet u zeker dat u de bestelling wilt verwijderen?', onCancel: () => onCancelOrderDeleteClicked(), onConfirm: () => handleOrderDelete(), onOpen: isOrderDeleteConfirmationPopup }), _jsx(ModalPopup, { title: 'Selecteer Regels', content: _jsx(PriceRequestOrderLineViewTable, { onClose: () => setIsPriceRequestOrderLineTableOpen(false), order: formData, priceRequestPrintPreview: handlePriceRequestPrintPreview }), onOpen: isPriceRequestOrderLineTableOpen, onClose: () => setIsPriceRequestOrderLineTableOpen(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Prijsaanvraag', content: _jsx(PriceRequestPrintPreview, { onClose: () => setIsPriceRequestFormVisible(false), order: orderPrintData, orderLineList: filteredOrderLineList, handleOrderStatusChange: handleOrderStatusChange, handelSendOrderPriceRequestPDfInEmailPopup: handelSendOrderPriceRequestPDfInEmailPopup }), onOpen: isPriceRequestFormVisible, onClose: () => setIsPriceRequestFormVisible(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Bestellingen', content: _jsx(OrderPreview, { onClose: () => setOrderPreviewOpen(false), order: orderPrintData, handelOrderSentAsEmailWithAttachmentPopup: handelOrderSentAsEmailWithAttachmentPopup }), onOpen: isOrderPreviewOpen, onClose: () => setOrderPreviewOpen(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Selecteer Regels', content: _jsx(CalculationSelectionForPurchaseInvoiceTable, { onClose: handleCalculationForPurchaseInvoiceTableClose, handleSelectedCalculationSubmit: handleSelectedCalculationForPurchaseInvoiceSubmit }), onOpen: isCalculationSelectionForPurchaseInvoiceTableOpen, onClose: () => setCalculationSelectionForPurchaseInvoiceTableOpen(false), modalWidth: 'xl' }), orderEmailTemplate && orderEmailTemplate.trim() !== '' && (_jsx(ModalPopup, { title: 'Verzend e-mail', content: _jsx(EmailEditorForm, { onClose: handelOrderSentAsEmailClose, isAttachmentAdded: true, emailWithAttachmentDto: {
                                attachment: orderDocument,
                                attachmentName: 'Bestelling-' +
                                    formData.orderNumber +
                                    '-' +
                                    String(new Date().getDate()).padStart(2, '0') +
                                    String(new Date().getMonth() + 1).padStart(2, '0') +
                                    new Date().getFullYear() +
                                    '.pdf',
                                to: crediture?.email ?? '',
                                subject: 'Bestelling ' + formData?.orderNumber,
                                emailBody: orderEmailTemplate
                            }, OnEmailSend: handleEmailSendSuccessForOrder }), onOpen: isOrderSentAsEmailViewOpen, onClose: handelOrderSentAsEmailClose, modalWidth: 'lg' })), priceRequestEmailTemplate && priceRequestEmailTemplate.trim() !== '' && (_jsx(ModalPopup, { title: 'Verzend e-mail', content: _jsx(EmailEditorForm, { onClose: handelSendOrderPriceRequestPDfInEmailPopupClose, isAttachmentAdded: true, emailWithAttachmentDto: {
                                attachment: orderPriceRequestDocument,
                                attachmentName: 'Prijsaanvraag-' +
                                    formData.orderNumber +
                                    '-' +
                                    String(new Date().getDate()).padStart(2, '0') +
                                    String(new Date().getMonth() + 1).padStart(2, '0') +
                                    new Date().getFullYear() +
                                    '.pdf',
                                to: crediture?.email ?? '',
                                subject: 'Bestelling ' + formData?.orderNumber,
                                emailBody: priceRequestEmailTemplate
                            }, OnEmailSend: handleEmailSendSuccessForPriceRequest }), onOpen: isOrderPriceRequestSentAsEmailViewOpen, onClose: handelSendOrderPriceRequestPDfInEmailPopupClose, modalWidth: 'lg' }))] }), updateModulePermissionStatus && !moduleLocked ? (_jsx(PersistentWarningMessage, { recordId: formData.id, moduleId: VisserModule.Bestellingen, handleIsModuleLockReset: handleOrderOnModuleLockReset })) : (''), moduleLocked ? _jsx(PersistentInfoMessage, { recordId: formData.id, moduleId: VisserModule.Bestellingen }) : ''] }));
};
export default OrderView;
